import { Warehouse } from "@secondcloset/types";
import { Tag, Typography } from "antd";
import { startCase, toLower } from "lodash";
import moment from "moment";
import React, { FC } from "react";
import { useHistory } from "react-router";
import { useQuery } from "react-query";
import styled from "styled-components";
import { fetchReturns, ReturnQuery } from "../../../../../hooks/api/warehouse/returns";
import Table from "../Table";
import { ReturnStatus, ReturnType, statusTagColorConfig } from "./helpers";
import { isEmpty } from "lodash-es";

type Return = Warehouse.Return;

const StyledProductsTable = styled.div`
  td.ant-table-row-expand-icon-cell {
    text-overflow: inherit;
  }
`;

interface ReturnsTableProps {
  query: ReturnQuery;
}

const ReturnsTable: FC<ReturnsTableProps> = ({ query }) => {
  const history = useHistory();
  const organizationID = query.organization_id;

  const { data: returns, isLoading: loading } = useQuery(["fetchReturns", query], () => fetchReturns(query), {
    enabled: !isEmpty(query),
  });

  const handleNavigation = (id: string) => {
    history.push(`/organizations/${organizationID}/returns/${id}`);
  };

  const renderText = (text?: string) => <Typography.Text>{text || ""}</Typography.Text>;

  const renderLink = (text: string, record: Return) => (
    <Typography.Link onClick={() => handleNavigation(record?.id as string)}>{text || ""}</Typography.Link>
  );

  const renderDate = (date?: Date) => <Typography.Text>{moment(date).format("lll")} EST</Typography.Text>;

  const renderStatus = (status: string) => (
    <Tag style={{ borderRadius: 25 }} color={statusTagColorConfig?.[status as ReturnStatus]}>
      {startCase(toLower(status))}
    </Tag>
  );

  const renderType = (type: string) => {
    const formattedType = type === ReturnType.REGULAR ? "Regular" : "RTS";
    return <Typography.Text>{formattedType}</Typography.Text>;
  };

  const columns = [
    {
      title: "RMA",
      key: "rma",
      dataIndex: "rma",
      render: renderLink,
    },
    {
      title: "Ex. Order #",
      key: "external_order_number",
      dataIndex: "external_order_number",
      render: renderText,
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: renderStatus,
    },
    {
      title: "Return Requested",
      key: "created_at",
      dataIndex: "created_at",
      render: renderDate,
    },
    {
      title: "Date Completed",
      key: "updated_at",
      dataIndex: "updated_at",
      render: renderDate,
    },
    {
      title: "Type",
      key: "type",
      dataIndex: "type",
      render: renderType,
    },
  ];
  const tableProps = {
    columns,
    dataSource: returns?.items,
    loading,
  };
  return (
    <div className="fulfillment-table" id="products-table">
      <StyledProductsTable>
        <Table
          headerButtons={null}
          tableProps={tableProps}
          title="Returns"
          fullListLink={organizationID ? `/organizations/${organizationID}/returns` : null}
        />
      </StyledProductsTable>
    </div>
  );
};

export default ReturnsTable;
